<template>
  <v-expansion-panel class="CollapsibleCard mb-6">
    <v-expansion-panel-header expand-icon="$sl-arrow-right" class="arrow-leftside">
      <v-row no-gutters>
        <h5 class="mb-0 ml-2 py-2 align-self-center">
          <slot name="header"></slot>
        </h5>
        <span class="align-self-center ml-4 flex-grow-1">
          <span class="CollapsibleCard__info"><slot v-if="!editMode" name="info"></slot></span>
          <span class="CollapsibleCard__detailsinfo"><slot v-if="!editMode" name="detailsinfo"></slot></span>
          <slot v-if="editMode" name="editinfo"></slot>
        </span>
        <div class="align-self-center actions">
          <v-btn
            color="secondary"
            icon
            v-if="editable && !editMode"
            @click.native.stop="editClick"
            :disabled="disabled"
          >
            <v-icon size="30">$sl-edit</v-icon>
          </v-btn>
          <div color="secondary" class="mt-1" v-if="editMode" @click="editCancel">
            <slot name="cancel"></slot>
          </div>
          <div class="ml-2 mt-1" v-if="editMode" @click="saveClick">
            <slot name="save"></slot>
          </div>
        </div>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot v-if="!editMode" name="view"></slot>
      <slot v-if="editMode" name="edit"></slot>
      <slot></slot>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: 'CollapsibleCard',
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      editMode: this.editing
    }
  },
  watch: {
    editing: {
      handler: function () {
        this.editMode = this.editing
      }
    }
  },
  methods: {
    editClick() {
      this.editMode = true
    },
    editCancel(e) {
      e.stopPropagation()
      this.editMode = false
    },
    saveClick(e) {
      e.stopPropagation()
    }
  }
}
</script>

<style lang="scss">
.CollapsibleCard {
  &__info {
    display: inline;
  }
  &__detailsinfo {
    display: none;
  }
}
.v-expansion-panel--active.CollapsibleCard {
  .CollapsibleCard__info {
    display: none;
  }
  .CollapsibleCard__detailsinfo {
    display: inline;
  }
}
</style>